exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-logo[data-v-5cd7f419]{display:flex;flex-direction:row;justify-content:center;align-items:center;margin-top:32px;width:100%}.bottom-logo__group[data-v-5cd7f419]{text-decoration:none;display:flex;color:#d9d9d9;font:normal normal 100 10px/11px Stolzl,Arial,sans-serif;user-select:none}[data-theme-new=theme-3] .bottom-logo__group[data-v-5cd7f419]{color:#757575}.bottom-logo__group__img[data-v-5cd7f419]{display:block;margin-left:4px}", ""]);

// exports
